module.exports = __webpack_public_path__ + "static/media/Masego + FKJ - Tadow.c671b1c7.mp3";